module.exports = __webpack_public_path__ + "static/media/calendar.072075c5.svg";